module.exports = __webpack_public_path__ + "static/media/LightBlueRectangle.ae19ce2c.svg";